import {Col, Row, Grid} from "antd";
import { useNavigate } from 'react-router-dom';
import {MyButton, MyText} from "../../../common";
import {WaveContainer} from "../WaveContainer";
import SectionMainImg from '../../../../assets/images/pages/Main/section4-5.webp'
import SectionImg1 from '../../../../assets/images/pages/Main/section4-img1.webp'
import SectionImg2 from '../../../../assets/images/pages/Main/section2-img2.webp'

import SectionImg4 from '../../../../assets/images/pages/Main/section4-4.webp'
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import {useTranslation} from "react-i18next";
const isMobile = window.innerWidth < 768;

export const Section4 = () => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  return (
    <WaveContainer
      isBottom
      bottomColor='blue'
      containerStyle={{
        backgroundColor: '#fff',
        paddingBottom: 100,
        paddingTop: screens.xs || isTablet ? 100 : 0,
      }}>
      <Row justify="center">
        <Col span={20} >
          <Row gutter={[48, 48]} align="middle" style={screens.xs || isTablet ? { display: 'flex', flexDirection: 'column' } : {}}>
            <Col span={12} style={screens.xs || isTablet ? { maxWidth: '100%' } : {}}>
              <img src={SectionMainImg} style={{transform: (screens.xs || isTablet ) ? '' : 'translateX(-10%) scale(0.8)'}}/>
              <img
                src={SectionImg1}
                style={{
                  position: 'absolute',
                  top: screens.xs || isTablet ? '-15%' : '2%',
                  left: '-4%',
                  width: '135px',
                  height: '128px',
                }}
              />
              <img
                src={SectionImg2}
                style={{
                  position: 'absolute',
                  bottom: screens.xs || isTablet ? '-8%' : '2%',
                  right: screens.xs || isTablet ? '0%' : '10%',
                  width: screens.xs || isTablet ? '94px' : '163px',
                  height: screens.xs || isTablet ? '94px' : '163px',
                }}
              />
            </Col>
            <Col span={isTablet ? 12 : 8} style={screens.xs || isTablet ? { maxWidth: '100%' } : {}}>
            
              <Row gutter={[24, 24]}>
                <Col span={24} style={{textAlign: screens.xs || isTablet ? 'center' : 'left'}}>
                  <MyText size={screens.xs || isTablet ? 32 : 48} color='#0A033C' weight={800} style={{fontFamily: 'Nunito', lineHeight: isTablet ? '34px' : "auto"}}>
                    {t("educationalCartoons")}
                  </MyText>
                </Col>

                <Col span={24} style={{textAlign: screens.xs || isTablet ? 'center' : 'left'}}>
                  <MyText size={20} color='#68727D' weight={400}  lineHeight={isTablet ? '26px' : '32px'}>
                    {t("gameVisualization")}
                  </MyText>
                </Col>
                <Col span={24} style={screens.xs || isTablet ? { display: 'flex', justifyContent: 'center' } : {}}>
                  <MyButton color='orange' type='primary' style={screens.xs ? { width: '100%', height: '56px', fontSize: '22px' } : {}} onClick={() => embeddedNavigate('/video')} >
                    {t("allCartoons")}
                  </MyButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </WaveContainer>
  )
}